/* eslint-disable import/no-named-as-default */
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { apiSlice } from '../services/api';
import { directusApi } from '../services/directus.api';
import { ideasApi } from '../services/idea.api';
import { partnersApi } from '../services/partners.api';
import { postsApi } from '../services/posts.api';
import { psyToolsApi } from '../services/psyTools.api';
import { tariffApi } from '../services/tariff.api';
import { planHistoryApi } from '../services/planHistory.api';
import { usersApi } from '../services/users.api';
import { walletApi } from '../services/wallet.api';
import { consultationResultsApi } from '../services/consultation-results.api';
import { consultationsApi } from '../services/consultations.api';
import { aiSupervisorApi } from '../services/aiSupervisor.api';
import { colorCodeApi } from '../services/colorCode.api';
import { cloudsApi } from '../services/clouds.api';
import { billingApi } from '../services/billing.api';
import { consultationAudioApi } from '../services/consultation-audio.api';
import { catalogProfileApi } from '../services/catalogProfile.api';

import appSettingsSlice from './appSettings.slice';
import authSlice from './auth.slice';
import dpdgStateSlice from './dpdg.slice';
import activeToolStateSlice from './meetActiveTool.slice';
import macStateSlice from './mac.slice';
import emotionsGroupSlice from './emotionsGroup.slice';
import planHistorySlice from './planHistory.slice';
import psyToolsSlice from './psyTools.slice';
import tariffSlice from './tariff.slice';
import walletSlice from './wallet.slice';
import wheelStateSlice from './wheel.slice';

export const store = configureStore({
  reducer: {
    authSlice,
    psyToolsSlice,
    dpdgStateSlice,
    macStateSlice,
    emotionsGroupSlice,
    wheelStateSlice,
    activeToolStateSlice,
    walletSlice,
    tariffSlice,
    planHistorySlice,
    appSettingsSlice,
    [directusApi.reducerPath]: directusApi.reducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [psyToolsApi.reducerPath]: psyToolsApi.reducer,
    [postsApi.reducerPath]: postsApi.reducer,
    [ideasApi.reducerPath]: ideasApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [tariffApi.reducerPath]: tariffApi.reducer,
    [planHistoryApi.reducerPath]: planHistoryApi.reducer,
    [partnersApi.reducerPath]: partnersApi.reducer,
    [consultationResultsApi.reducerPath]: consultationResultsApi.reducer,
    [consultationsApi.reducerPath]: consultationsApi.reducer,
    [aiSupervisorApi.reducerPath]: aiSupervisorApi.reducer,
    [colorCodeApi.reducerPath]: colorCodeApi.reducer,
    [cloudsApi.reducerPath]: cloudsApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [consultationAudioApi.reducerPath]: consultationAudioApi.reducer,
    [catalogProfileApi.reducerPath]: catalogProfileApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['/upload-avatar'],
      },
    }).concat(
      directusApi.middleware,
      apiSlice.middleware,
      usersApi.middleware,
      psyToolsApi.middleware,
      postsApi.middleware,
      ideasApi.middleware,
      walletApi.middleware,
      tariffApi.middleware,
      planHistoryApi.middleware,
      partnersApi.middleware,
      consultationResultsApi.middleware,
      consultationsApi.middleware,
      aiSupervisorApi.middleware,
      colorCodeApi.middleware,
      cloudsApi.middleware,
      billingApi.middleware,
      consultationAudioApi.middleware,
      catalogProfileApi.middleware,
    ),
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
